export enum ServiceName {
  Gateway = 'gateway',
  SSO = 'sso',
  File = 'file',
  Audit = 'audit',
  Company = 'company',
  Deal = 'deal',
  Document = 'document',
  Integration = 'integration',
  Notification = 'notification',
  Workflow = 'workflow',
}
